// custom typefaces
import "typeface-lora"
import "typeface-source-sans-pro"

// TaildwindCSS
import "tailwindcss/base.css"

// Syntax highlighting
// import "prismjs/themes/prism-tomorrow.css"
// import "prismjs/plugins/line-numbers/prism-line-numbers.css"

import "tailwindcss/components.css"
import "tailwindcss/utilities.css"
